module.exports = __webpack_public_path__ + "static/bankia_grey-96b6c12f6bff695b39e1a28e41f09476.svg";